<template>
  <Carousel
    class="m-carousel"
    snap-align="center"
    :autoplay="autoPlay ? 5000 : 0"
    :wrap-around="true"
    :breakpoints="breakpoints"
  >
    <slot />
    <template #addons>
      <Pagination />
    </template>
  </Carousel>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel } from 'vue3-carousel';

const Pagination = defineAsyncComponent(() =>
  import('vue3-carousel').then((module) => module.Pagination)
);

export default defineComponent({
  name: 'MCarousel',
  components: { Carousel, Pagination },
  props: {
    autoPlay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      breakpoints: {
        0: {
          itemsToShow: 1.2
        },
        769: {
          itemsToShow: 1.61
        }
      }
    };
  }
});
</script>

<style lang="scss" scoped>
:deep(.carousel__pagination) {
  padding: 10px;
}

:deep(.carousel__pagination-button) {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  border-radius: 50%;
  background-color: $gray-scale-color-30;

  &:after {
    display: none;
  }
}

:deep(.carousel__pagination-button--active) {
  background-color: $main-color;
}
</style>
